
export enum ClaimNoteTypeCd {
	EMAIL = 'Email',
	EXAMINER_USE = 'ExaminerUse',
	SERVICE_CENTER_CHARGEABILITY = 'ServiceCenterChargeability'}

